module.exports = __webpack_public_path__ + "static/media/photo-icon.b3b21b01.svg";